import { render, staticRenderFns } from "./facilities.vue?vue&type=template&id=e8063be0&scoped=true&"
import script from "./facilities.vue?vue&type=script&lang=js&"
export * from "./facilities.vue?vue&type=script&lang=js&"
import style0 from "./facilities.vue?vue&type=style&index=0&id=e8063be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8063be0",
  null
  
)

export default component.exports